module.exports = __webpack_public_path__ + "static/media/coins.c8c35834.svg";